import { FC } from 'react'
import { IndicatorContainerProps } from 'react-select'

const Indicator: FC<IndicatorContainerProps<any, true>> = (props) => {
  return <div className='arrow-indicator'></div>
}

export default Indicator
